import { render, staticRenderFns } from "./SelectDenom.vue?vue&type=template&id=e1198524&lang=pug"
import script from "./SelectDenom.vue?vue&type=script&lang=js"
export * from "./SelectDenom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports